import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomTableSortState } from '@components/custom-table/types';

export interface MemberSortState {
  branchId: string;
  sort: CustomTableSortState;
}

interface MemberState {
  currentBranchFilter: {
    branchId: string;
    branchName: string;
  };
  currentGroupIds: string[];
  currentSearchTerm: string;
  currentPage: number;
  currentSort: MemberSortState | null;
}
const initialState: MemberState = {
  currentBranchFilter: {
    branchId: '',
    branchName: ''
  },
  currentGroupIds: [],
  currentSearchTerm: '',
  currentPage: 1,
  currentSort: null
};

export const memberSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    updateBranchFilter: (
      state,
      action: PayloadAction<{ branchId: string; branchName: string }>
    ) => {
      state.currentBranchFilter = action.payload;
    },
    updateCurrentGroupIds: (state, action: PayloadAction<string[]>) => {
      state.currentGroupIds = action.payload;
    },
    updateCurrentSearchTerm: (state, action: PayloadAction<string>) => {
      state.currentSearchTerm = action.payload;
    },
    updateCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    updateCurrentSort: (
      state,
      action: PayloadAction<MemberSortState | null>
    ) => {
      state.currentSort = action.payload;
    },
    resetMemberState: () => initialState
  }
});

export const {
  updateBranchFilter,
  updateCurrentGroupIds,
  updateCurrentSearchTerm,
  updateCurrentPage,
  updateCurrentSort,
  resetMemberState
} = memberSlice.actions;
export default memberSlice.reducer;
